import React from 'react';
const CommentContext = React.createContext();
export default CommentContext;
